export default "__VITE_ASSET__YswHyAft__"